/**
 * Centralized route configuration
 * This file defines public routes that don't require authentication
 *
 * IMPORTANT: When adding new public pages, update this file ONLY
 * All components will automatically use the updated list
 */

/**
 * Public routes that don't require authentication or workspace context
 * These pages can be accessed without logging in
 */
export const PUBLIC_ROUTE_SLUGS = [
  'login',
  'not-found',
  'verify-email',
  'verify-email-change',
  'link-account',
  'forgot-password',
  'reset-password',
  'password-setup',
  'password-change',
  'trial-signup',
  'trial-success',
  'sso-consent',
  // METALARK-835: cross-customer invitation acceptance lands here
  // from the email link. The page itself handles the auth gate
  // (preview is anonymous; accept/decline POST routes through a
  // returnto-aware /login link when no session is present).
  'accept-invitation'
];

/**
 * Public route component names (with -page suffix)
 * Used by index.tag and router
 */
export const PUBLIC_ROUTE_COMPONENTS = PUBLIC_ROUTE_SLUGS.map(slug => `${slug}-page`);

/**
 * Check if a route hash is a public route
 * @param {string} hash - The hash string (e.g., '#/trial-signup')
 * @returns {boolean} True if the route is public
 */
export function isPublicRoute(hash) {
  if (!hash) return false;

  const normalizedHash = hash.toLowerCase();
  return PUBLIC_ROUTE_SLUGS.some(slug => normalizedHash.includes(slug));
}

/**
 * Check if a component name is a public component
 * @param {string} componentName - The component name (e.g., 'trial-signup-page')
 * @returns {boolean} True if the component is public
 */
export function isPublicComponent(componentName) {
  if (!componentName) return false;

  return PUBLIC_ROUTE_COMPONENTS.includes(componentName);
}